import Instance from '../../../../utils/Axios';

const GetDiasMarcadosEmpresa = (recursoId) => async (dispatch) => {
  const stateToken = localStorage.token;
  if (recursoId) {
    await Instance()
      .get(`/syncdiasferias/all_dias_ferias_marcados_empresa/${recursoId}`)
      .then(({ data }) => {
        if (stateToken && dispatch) {
          dispatch({
            type: 'GET_DIAS_MARCADOS_EMPRESA',
            payload: data.yData.all_dias_ferias_marcados_empresa,
          });
        }
      })
      .catch(({ err }) => console.log(err));
  }
};

export default GetDiasMarcadosEmpresa;
